import { render, staticRenderFns } from "./OvalShadow.vue?vue&type=template&id=753b046e&scoped=true"
import script from "./OvalShadow.vue?vue&type=script&lang=js"
export * from "./OvalShadow.vue?vue&type=script&lang=js"
import style0 from "./OvalShadow.vue?vue&type=style&index=0&id=753b046e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753b046e",
  null
  
)

export default component.exports